<template>
  <div class="row m-0 me-2 ms-2 mb-5">
    <div class="accordion accordion-flush p-0" id="accordionFlushExample">
      <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingTwo">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
            Ιστορία
          </button>
        </h2>
        <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo"
          data-bs-parent="#accordionFlushExample">
          <div class="accordion-body">
            <MarkdownItVue :content="history" class="mt-3" />
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingThree">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
            Συμβούλιο<span v-if="auth" class="btn btn-sm btn-outline-danger" data-bs-toggle="modal" data-bs-target="#memberModal"> Add Member</span>
          </button>
        </h2>
        <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree"
          data-bs-parent="#accordionFlushExample">
          <div class="accordion-body m-0 p-0">
            <Board />
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingThree">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
            Αλληλογραφία
          </button>
        </h2>
        <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingThree"
          data-bs-parent="#accordionFlushExample">
          <div class="accordion-body m-0 p-0">
            
            <form v-if="auth" class="form border border shadow-sm p-3 mb-5" v-on:submit="addDocument">
              <h3>Add Document</h3>
              <div class="mb-3">
                <input type="text" v-model="doc.title" class="form-control" placeholder="Document Title" required />
              </div>
              <div class="mb-3">
                <input type="url" v-model="doc.url" class="form-control" placeholder="URL (Google-Drive Link)" required />
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </form>


            <ul class="mt-4" v-for="doc in docs" v-bind:key="doc._id">
              <DocEntry :doc="doc" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'
import markdown from "raw-loader!../assets/History.md";
import Board from '../components/Board'
import axios from 'axios';
import DocEntry from '../components/DocEntry.vue';
export default {
  computed: {
    auth () {
      return this.$store.state.auth;
    }
  },
  data() {
    return {
      history: markdown,
      title: "",
      url: "",
      docs: [],
      doc: {
        title: "",
        url: ""
      },
    }
  },
  components: {
    Board,
    MarkdownItVue,
    DocEntry
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    async addDocument() {
      const result = await axios.post("/api/document", this.doc);
      this.docs.push(result.data);
      this.doc = {
        title: "",
        url: ""
      }
      window.location.reload();
    },
    async fetchDocuments() {
      const result = await axios.get("/api/documents");
      this.docs = result.data;
    }
  },
}
</script>
